import React from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'

import { getLabel } from 'helpers/language'
import { isWindow } from 'helpers/common'
import { IconArrowDown } from '../Icons'

export interface IPages {
  key: string
  label: JSX.Element | string
  active?: boolean
}

export interface BreadcrumbProps {
  id?: string
  name?: string
  className?: string
  disabled?: boolean
  renderSeparator?: React.ReactNode
  pages: IPages[]
}

const Breadcrumb: React.FC<BreadcrumbProps> = (props: BreadcrumbProps) => {
  const {
    className,
    disabled = false,
    pages,
    renderSeparator = (
      <IconArrowDown className='icon--gray-breadcrumb' variants='sm' />
    ),
    ...others
  } = props

  const cn = clsx('breadcrumb', className)
  // const items = React.Children.toArray(children)
  const isFirst = 0
  const isLast = pages.length > 0 ? pages.length - 1 : 0
  const activeIndex = pages.findIndex((page) => page?.active)
  const isActive = activeIndex === -1 ? isLast : activeIndex
  const isOne = pages.length === 1

  const renderLink = (link: JSX.Element | string) => {
    return typeof link === 'string' ? getLabel(link) : link
  }

  return (
    <nav className={cn} {...others}>
      <ul className='breadcrumb__list'>
        {pages.map((page, index) => (
          <li
            key={index}
            className={clsx(
              'breadcrumb__item',
              disabled && 'breadcrumb__item--disabled',
              isFirst === index && 'breadcrumb__item--first',
              isActive === index && 'breadcrumb__item--last',
              isOne && 'breadcrumb__item--one',
            )}
            data-testid='breadcrumb-test-list'
          >
            {!(isFirst === index) && (
              <span
                className={clsx(
                  'breadcrumb__separator',
                  isWindow && 'breadcrumb__separator--window',
                )}
              >
                {renderSeparator}
              </span>
            )}
            <Link key={page.key} to={page.key}>
              {renderLink(page.label)}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default Breadcrumb
